import { marked } from 'marked';
const insane = require('insane');

export function markdownToHTML(markdown: string): string {
  const renderer = new marked.Renderer();
  const originalLinkRenderer = renderer.link;

  renderer.link = function (args) {
    const html = originalLinkRenderer.call(this, args);
    return html.replace('<a ', '<a target="_blank" ');
  };

  return insane(marked(markdown, { renderer }));
}
